import React from "react";
import {
  buildOrdersPageModel,
  filterOrders,
  getNextDueOrder,
} from "../utils/ordersPageData.js";

export default function useOrdersPageData(initialReadModel = null) {
  const [searchQuery, setSearchQuery] = React.useState("");
  const [statusFilter, setStatusFilter] = React.useState("all");
  const [grainFilter, setGrainFilter] = React.useState("all");
  const pageModel = React.useMemo(
    () => buildOrdersPageModel(initialReadModel),
    [initialReadModel],
  );
  const deferredSearchQuery = React.useDeferredValue(searchQuery.trim().toLowerCase());
  const filteredOrders = React.useMemo(
    () => filterOrders(pageModel.orders, {
      grainFilter,
      searchQuery: deferredSearchQuery,
      statusFilter,
    }),
    [deferredSearchQuery, grainFilter, pageModel.orders, statusFilter],
  );
  const visibleTonnage = React.useMemo(
    () => filteredOrders.reduce((sum, order) => sum + order.quantityTons, 0),
    [filteredOrders],
  );

  return {
    ...pageModel,
    filterCounts: {
      all: pageModel.summary.total,
      assigned: pageModel.summary.assigned,
      attention: pageModel.summary.attention,
      pending: pageModel.summary.pending,
    },
    filteredOrders,
    grainFilter,
    nextDueOrder: React.useMemo(() => getNextDueOrder(filteredOrders), [filteredOrders]),
    searchQuery,
    setGrainFilter,
    setStatusFilter,
    statusFilter,
    updateSearchQuery(nextQuery) {
      React.startTransition(() => {
        setSearchQuery(nextQuery);
      });
    },
    visibleTonnage,
  };
}